<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="标签">
								<a-input v-model="queryParams.name" placeholder="名称" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="性别">
								<a-select v-model="queryParams.targetSex" placeholder="请选择" default-value="">
									<a-select-option value="MALE">男</a-select-option>
									<a-select-option value="FEMALE">女</a-select-option>
									<a-select-option value="INTERSEX">通用</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="阶段">
								<a-select v-model="queryParams.step" placeholder="请选择" default-value="">
									<a-select-option value="1">一阶段</a-select-option>
									<a-select-option value="2">二阶段</a-select-option>
									<a-select-option value="3">三阶段</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="创建时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button type="primary" icon="plus" v-has="'/content/accostTplAdd'" @click="add">新增</a-button>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">

				<template slot="sex" slot-scope="record">
					<span class="user-right-detail" v-if="record.targetSex=='MALE'">男</span>
					<span class="user-right-detail" v-else-if="record.targetSex=='FEMALE'">女</span>
					<span class="user-right-detail" v-else>通用</span>
				</template>
				
				<span slot="isEnable" slot-scope="record">
					<label v-if="record.isEnable == 'Y'" class="normal">正常</label>
					<label v-else class="disabled">禁用</label>
				</span>

				<template slot="action" slot-scope="record">
					<template v-if="record.isEnable=='N'">
						<a v-has="'/content/accostTplSetEnable'" @click="setEnable(record.id, 'Y')">启用</a>
						<a-divider type="vertical" />
					</template>
					<template v-else>
						<a v-has="'/content/accostTplSetEnable'" @click="setEnable(record.id, 'N')">停用</a>
						<a-divider type="vertical" />
					</template>
					<a v-has="'/content/accostTplUpdate'" @click="update(record)">修改</a>
					<a-divider type="vertical" />
					<a-popconfirm placement="topRight" title="你确定要删除本条记录?" @confirm="accostTplDel(record.id)">
						<a v-has="'/content/accostTplDel'" href="#">删除</a>
					</a-popconfirm>
				</template>
			</a-table>

			<Accost-form-modal ref="AccostForm" :visible="AccostFormVisible" :loading="AccostFormLoading" :model="AccostFormModel"
				@cancel="AccostFormCancel" @ok="AccostFormOk" />

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>
	</div>
</template>

<script>
	import moment from "moment";
	import AccostFormModal from "@/pages/content/accost/AccostForm.vue";
	import {
		accostList,
		accostAdd,
		accostUpdate,
		accostDel,
		accostSetEnable
	} from "@/api/content/accost.js";

	const tableColumns = [{
			title: '#',
			dataIndex: 'id'
		},
		{
			title: '场景标签',
			dataIndex: 'name'
		},
		{
			title: '目标性别',
			scopedSlots: {
				customRender: 'sex'
			}
		},
		{
			title: '内容',
			dataIndex: 'message'
		},
		{
			title: '阶段',
			dataIndex: 'step'
		},
		{
			title: '状态',
			scopedSlots: {
				customRender: 'isEnable'
			}
		},
		{
			title: '创建时间',
			dataIndex: 'created'
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			AccostFormModal
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				AccostFormVisible: false,
				AccostFormLoading: false,
				AccostFormModel: null,
				activeTime: [],
				createTime: [],
				photosPreviewVisible: false, // 预览modal显示状态
				photosPreviewImage: '', // 当前预览图片URL
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				accostList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;

					this.tableLoading = false;
				});
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			onActiveTime(values) {
				this.queryParams.startActiveTime = moment(values[0]).unix();
				this.queryParams.endActiveTime = moment(values[1]).unix();
			},
			add() {
				this.AccostFormModel = null;
				this.AccostFormVisible = true;
				this.$nextTick(() => {
					if (this.$refs.AccostForm && this.$refs.AccostForm.initForm) {
						this.$refs.AccostForm.initForm();
					}
				});
			},
			update(record) {
				this.AccostFormModel = {
					...record
				};
				this.AccostFormVisible = true;
			},
			accostDel(id) {
				accostDel(id).then(() => {
					this.fetchTableData();
				})
			},
			setEnable(id, enable) {
				accostSetEnable(id, enable).then(() => {
					this.fetchTableData();
					if (enable == 'Y') {
						this.$message.success(`模版:${id}，已启用`);
					} else {
						this.$message.success(`模版:${id}，已禁用`);
					}
				})
			},
			AccostFormOk() {
				const accostForm = this.$refs.AccostForm;
				if (!accostForm || !accostForm.$refs.adminForm) {
					return;
				}
				accostForm.$refs.adminForm.validate(valid => {
					if (!valid) {
						return;
					}
					const values = { ...accostForm.form };
					this.AccostFormLoading = true;
					if (values.id > 0) {
						accostUpdate(values).then(() => {
							this.AccostFormAfter('修改用户成功');
						}).catch(() => {
							this.AccostFormLoading = false;
						});
					} else {
						accostAdd(values).then(() => {
							this.AccostFormAfter('新增用户成功');
						}).catch(() => {
							this.AccostFormLoading = false;
						});
					}
				});
			},
			AccostFormCancel() {
				this.AccostFormModel = null;
				this.AccostFormVisible = false;
				if (this.$refs.AccostForm && this.$refs.AccostForm.initForm) {
					this.$refs.AccostForm.initForm();
				}
			},
			AccostFormAfter(message) {
				this.AccostFormVisible = false;
				this.AccostFormLoading = false;
				if (this.$refs.AccostForm && this.$refs.AccostForm.initForm) {
					this.$refs.AccostForm.initForm();
				}
				this.fetchTableData();
				this.$message.success(message);
			},
			rest() {
				this.activeTime = [];
				this.createTime = [];
				this.queryParams = {}
			},
		}
	}
</script>

<style lang="less" scoped>
	
</style>